import NavBar from './NavBar.jsx';

import './nav-bar.scss';
import './nav-bar-media-screen.scss';

export default NavBar;
